import { compose } from 'redux';
import { connect } from 'react-redux';
import OrganizerPosterList, { Header } from '../../pages/OrganizerList/OrganizerPosterList';
import { getCompanyInfoRequested, getCompanyInfoClear } from '../../actions/OrganizerPosterList';
import {
    getFavoriteCompaniesRequested,
    getFavoriteCompaniesClear,
    updateFavoriteCompaniesRequested,
    updateFavoriteCompaniesClear,
} from '../../actions/FavoriteCompanies';
import Selector from '../../selectors/OrganizerPosterList';
import withAuthUser from '../../common/WithAuthUser';

const mapStateToProps = (state) => {
    const isLoading = state.registrationOrganizer.registrationOrganizer.isFetching
    || state.organizerPosterList.getList.isFetching
    || state.favoriteCompanies.get.isFetching
    || state.adminSettingCustom.getCustomText.isFetching;
    return ({
        locale: state.locale.lang.current,
        companyIDs: state.favoriteCompanies.get.data.company_ids,
        companies: Selector.createOrganizerPosterListSelector()(state),
        eventInfo: state.registrationOrganizer.registrationOrganizer.data,
        isLoading,
        successGetList: state.organizerPosterList.getList.success,
        errorsGetList: state.organizerPosterList.getList.errors,
        customColorExhibitor: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
        updateFavoriteSuccess: state.favoriteCompanies.update.success,
    });
};

const mapDispatchToProps = (dispatch) => ({
    getFavoriteCompanies: (locale) => {
        dispatch(getFavoriteCompaniesRequested({ language: locale }));
    },
    clearFavoriteCompanies: () => {
        dispatch(getFavoriteCompaniesClear());
    },
    getCompanyInfo: (event, params, locale) => {
        const formattedParams = {
            company_ids: params.companyIDs,
            page: params.page || 1,
            language: locale,
        };
        dispatch(getCompanyInfoRequested({
            event,
            params: formattedParams,
            mergeOldData: true,
        }));
    },
    clearCompanyInfo: () => {
        dispatch(getCompanyInfoClear());
    },
    updateFavoriteCompanies: (companyIDs, locale) => {
        dispatch(updateFavoriteCompaniesRequested({ companyIDs, language: locale }));
    },
    clearUpdateFavorite: () => {
        dispatch(updateFavoriteCompaniesClear());
    },
});

export const OrganizerPosterHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(OrganizerPosterList);
